import { z } from "zod";
import { FinancialAccountType } from "@common/types/financialAccount";

export const UpdateAccountInfoBodySchema = z
    .object({
        accountType: z.nativeEnum(FinancialAccountType).optional(),
        institutionName: z.string().max(500).optional(),
        accountName: z.string().max(500).optional(),
        accountNumber: z.string().max(100).optional(),
    })
    .refine((data) => Object.keys(data).length > 0, {
        message: "At least one field must be provided",
    });
